import styled, { css } from "styled-components";
import { Copier } from "@beamcloud/design-system";

interface IProps {
  text: string;
}

const TerminalTextBox: React.FC<IProps> = ({ text }) => {
  return (
    <Container>
      <Caret>$</Caret>
      <Script>{text}</Script>
      <Copier icon="far-clipboard" text={text} />
    </Container>
  );
};

export default TerminalTextBox;

const Container = styled.div`
  ${({ theme }) => {
    return css`
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 12px 16px;
      gap: 12px;
      width: 100%;
      overflow: wrap;

      background-color: ${theme.colors.gray3};
      border: 1px solid ${theme.colors.gray6};
      border-radius: 8px;

      ${props => props.theme.styleSet.monoSm};
    `;
  }}
`;

const Caret = styled.span`
  color: ${props => props.theme.colors.gray11};
`;

const Script = styled.span`
  color: ${props => props.theme.colors.gray12};
  width: 100%;
`;
